import React, { useMemo } from "react";
import {
    Button,
    DefaultComponentProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FlexGrid,
    Typography,
} from '@albo-ui/core';

import { ItemType } from "../../../util/hooks/useCatalog";
import { FilterLeadType } from "../../customwidgets/leads-tracking-report/types";
import moment from "moment";
import { dateToString } from "../../../util/DateUtil";

moment.locale('es');

export type FiltersLeadDialogProps = {
    onConfirm: (selectedFilters: FilterLeadType) => void;
    onClose: () => void;
    open: boolean;
    status: ItemType[];
    selectedFilters: FilterLeadType,
} & DefaultComponentProps;

export const FiltersLeadSummary = ({
    onConfirm,
    onClose,
    open,
    className,
    style,
    selectedFilters,
    status,
}: FiltersLeadDialogProps) => {


    const statusDescriptions = useMemo(() => {
        const descriptions = selectedFilters?.lead_status?.map(s => {
            return status.find(ss => ss.name === s)?.metadata?.description
        })
        return descriptions
    }, [selectedFilters, status])


    return (
        <Dialog className={className} style={style} onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant="h2"> Detalle de la descarga</Typography>
            </DialogTitle>
            <DialogContent>
                <FlexGrid container
                    fullHeight
                    fullWidth
                    direction="column"
                    justify='space-between'
                    alignItems='flex-start'
                    spacing={2}>
                    <FlexGrid fullWidth
                        direction="row"
                        justify='space-between'
                        alignItems='space-between'
                        container
                        spacing={2}
                    >
                        <Typography variant="paragraph">El reporte se descargará con la selección de los filtros:</Typography>
                    </FlexGrid>

                    <FlexGrid fullWidth
                        direction="row"
                        justify='flex-start'
                        alignItems='flex-start'
                        container
                        spacing={2}
                    >
                        <Typography variant="paragraph" bold>Fecha:</Typography>
                        <Typography variant="paragraph">{dateToString(selectedFilters?.dates?.start)} - </Typography>
                        <Typography variant="paragraph">{dateToString(selectedFilters?.dates?.end)} </Typography>
                    </FlexGrid>
                    <FlexGrid fullWidth
                        direction="row"
                        justify='flex-start'
                        alignItems='flex-start'
                        container
                        spacing={2}
                    >
                        <Typography variant="paragraph" bold>Tipo:</Typography>
                        <Typography variant="paragraph">{selectedFilters?.lead_type?.join(", ")} </Typography>

                    </FlexGrid>
                    <FlexGrid fullWidth
                        direction="row"
                        justify='flex-start'
                        alignItems='flex-start'
                        container
                        spacing={2}
                    >
                        <Typography variant="paragraph" bold>Responsable:</Typography>
                        <Typography variant="paragraph">{selectedFilters?.lead_responsible?.join(", ")} </Typography>

                    </FlexGrid>

                    <FlexGrid fullWidth
                        direction="row"
                        justify='flex-start'
                        alignItems='flex-start'
                        container
                        spacing={2}
                    >
                        <Typography variant="paragraph" bold>Estatus:</Typography>
                        <Typography variant="paragraph">{statusDescriptions?.join(", ")} </Typography>

                    </FlexGrid>

                </FlexGrid>

            </DialogContent>
            <DialogActions>
                <FlexGrid
                    container
                    fullHeight
                    fullWidth
                    justify='space-between'
                    alignItems='flex-end'
                    style={{ marginTop: '20px' }}
                >
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={() => onConfirm(selectedFilters)} size='normal' >
                            Descargar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
